// import PreChatInvitation from '../prechat/PreChatInvitation';
import WidgetTypes from './enums/WidgetTypes';
export class WidgetCreator {
    async create(options) {
        if (options.widget == WidgetTypes.DropDown) {
            const module = await import(/* webpackChunkName: "dropdownInvitation" */ '../standardInvitation/DropDownInvitation')
            const DropDownInvitation = module.default;
            new DropDownInvitation(options)

        } else if (options.widget == WidgetTypes.Tab) {
            const module = await import(/* webpackChunkName: "tabInvitation" */ '../tab/TabInvitation')
            const TabInvitation = module.default;
            new TabInvitation(options)
        } else if (options.widget == WidgetTypes.Bar) {
            const module = await import(/* webpackChunkName: "barInvitation" */ '../bar/BarInvitation')
            const BarInvitation = module.default;
            new BarInvitation(options);

        } else if (options.widget == WidgetTypes.SMS) {
            const module = await import(/* webpackChunkName: "webSmsFormInvitation" */ '../sms/SMSInvitation')
            const SMSInvitation = module.default;
            new SMSInvitation(options)
        }
        else if (options.widget == WidgetTypes.DOM) {
            // return new DOMChatWindow(options);
            const module = await import(/* webpackChunkName: "DOMChatWindow" */ '../dom/DOMChatWindow')
            const DOMChatWindow = module.default;
            new DOMChatWindow(options)
        }
        else if (options.widget == WidgetTypes.ExitPopup) {
            // WE DO NOT NEED TO LOAD EXITPOPUP CODE AT INVITATION TIME 
            // WE LOADED AT WHEN WE NEED TO SHOW THE EXITPOPUP
            if (options.isPageRefreshed) {
                import(/* webpackChunkName: "exitChatWindow" */ '../exitpopup/ExitChatWindow').then(
                    (module) => {
                        const ExitChatWindow = module.default;
                        const chat = new ExitChatWindow(options);
                    }
                );
            }
        } else if (options.widget == WidgetTypes.PreChat) {
            // new PreChatInvitation(options);
            const module = await import(/* webpackChunkName: "PreChatInvitation" */ '../prechat/PreChatInvitation')
            const PreChatInvitation = module.default;
            new PreChatInvitation(options)
        } else if (options.widget == WidgetTypes.VisitorForm) {
            const module = await import(/* webpackChunkName: "visitorForm" */ '../visitorInfo/VisitorForm')
            const VisitorForm = module.default;
            new VisitorForm(options)
        } else if (options.widget == WidgetTypes.DynamicVisitorForm) {
            const module = await import(/* webpackChunkName: "dynamicVisitorForm" */ '../visitorInfo/DynamicVisitorForm')
            const DynamicVisitorForm = module.default;
            new DynamicVisitorForm(options)
        } else if (options.widget == WidgetTypes.WebSmsForm) {
            const module = await import(/* webpackChunkName: "webSmsFormInvitation" */ '../sms/WebSmsFormInvitation')
            const WebSmsFormInvitation = module.default;
            new WebSmsFormInvitation(options)
        } else if (options.widget == WidgetTypes.Test) {
            //return new ApexChat.TestInvitation(options);
        } else if (options.widget == WidgetTypes.VideoGreetInvitation) {
            const module = await import(/* webpackChunkName: "videoGreetInvitation" */ '../videogreet/VideoGreetInvitation')
            const VideoGreetInvitation = module.default;
            new VideoGreetInvitation(options)
        }
    }
}